import * as restErrorHandler from "@sharedJS/restErrorHandler";
import * as rest from "@sharedJS/rest";
import commonPopup from "@JS/shop/10-login-component/commonPopup";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";
import pushDataLayer from "@ocm/services/dataLayer";

let googleAuthenticateBtn;
let $loginForm;
let isSubscribed = false;
const contextPath = ocm.config.encodedContextPath;
const loginFormId = "#google-login-form";
const googleAuthenticateBtnClass = ".js-login-google";
let loadGoogleScript = false;

function init() {
	if (!isSubscribed) {
		OcmMessenger.subscribe(messengerPublicationTypes.REQUEST_LOGIN, init);
		isSubscribed = true;
	}

	// DOM
	googleAuthenticateBtn = document.querySelector(googleAuthenticateBtnClass);
	$loginForm = $(loginFormId);

	if (!googleAuthenticateBtn) {
		return;
	}

	if (_isApp()) {
		return;
	}

	if (!window.google && !loadGoogleScript) {
		initalizeGoogle();
	}
}

async function initalizeGoogle() {
	loadGoogleScript = true;
	await $.getScript("https://accounts.google.com/gsi/client");
	// initialisiere Google (darf nur einmal passieren)
	google.accounts.id.initialize({
		client_id: ocm.config.googleClientId,
		callback: authenticateWithGoogleAction,
	});

	// Rendere den Google-Button / iframe
	google.accounts.id.renderButton(googleAuthenticateBtn, {
		type: "standard",
		shape: "pill",
		theme: "outline",
		text: "signin_with",
		locale: ocm.config.language === "de" ? "de-DE" : "en-US",
		size: "large",
		width: "288",
		logo_alignment: "left",
		click_listener: googleTracking,
	});
}

function authenticateWithGoogleAction(googleUser) {
	const googleData = {
		serverUrl: `${contextPath}/rest/auth/google/`,
		tokenId: googleUser.credential,
		formId: loginFormId,
		rememberMe: true,
	};

	_doServerAuthentication(googleData);
}

function googleTracking() {
	const isLogin =
		// LoginLayer check
		document.querySelector(googleAuthenticateBtnClass)?.dataset?.isLogin === "true" ||
		// Landing Page check
		document.querySelector(".c-tabs__control:checked")?.classList?.contains("js-c-tabs__control--login");
	const { pageName } = window.recommendationData?.Recommendation?.pageData;
	const eventObj = {
		event: "GAevent",
		event_category: isLogin ? "S_LoginLayer" : "S_RegistrationLayer",
		event_action: "S_GoogleBtnClick",
		event_label: `S_${pageName}`,
	};
	pushDataLayer(eventObj);
}

function _doServerAuthentication(googleData) {
	_googleServerRequest(googleData);
}

function _googleServerRequest(googleData) {
	removeErrors();

	const postActionExists = $("#master-common-layer").attr("data-postActionJs");
	let dataType = "json";

	if (postActionExists) {
		dataType = "html";
	}
	$.ajax({
		url: googleData.serverUrl,
		dataType,
		type: "POST",
		data: googleData,
	})
		.done((responseData) => {
			if (postActionExists) {
				commonPopup.closeLayer();
				commonPopup.doStartPopupPostAction(responseData);
			} else {
				rest.handleRedirect(
					{ responseJSON: { redirectUrl: responseData.redirectUrl } },
					{ saveRedirectToHistory: false }
				);
			}
		})
		.fail(async (responseData) => {
			restErrorHandler.handleError(responseData, googleData.formId, _googleServerRequest, googleData);
			OcmMessenger.publish(messengerPublicationTypes.GOOGLE_LOGIN, {
				type: "ERROR",
				detail: responseData.responseJSON.globalErrorMessages,
			});
		});
}

//--------------------------
// Helper
//--------------------------
function removeErrors() {
	$loginForm.empty();
}

function _isApp() {
	// Facebook / Instagramm
	const ua = navigator.userAgent || navigator.vendor || window.opera;
	return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1 || ua.indexOf("Instagram") > -1;
}

export { init };
